import { dataHooks } from '@wix/data-hooks';

export const menuListDataHooks = dataHooks<{
  root: {};
  menuTitle: {};
  menuDescription: {};
  divider: {};
}>('menu-list');
